import React, { Component, PropTypes } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import { Tabs, Tab } from 'material-ui/Tabs';
import CircularProgress from 'material-ui/CircularProgress';
import FontIcon from 'material-ui/FontIcon';
import Paper from 'material-ui/Paper';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import TextField from 'material-ui/TextField';

import CommentBox from '../contracting/generic-components/comment-box';
import { sendRates, sendMessage, sendRateRequest } from './__store__/actions';

const styles = {
  content: {
    margin: '1em',
    padding: '1em 1em 1em 1em',
    borderRadius: '10px !important',
  },
  tabs: {
    '&>div:first-of-type': {
      backgroundColor: 'transparent !important',
    },
    '&>div:nth-of-type(2)': {
      borderBottom: '0.1em solid #e0e0e0 !important',
    },
  },
  tab: {
    textTransform: 'none !important',
    color: '#90a4ae !important',
    fontSize: '1.3em !important',
    '&.active': {
      color: '#3e5a6d !important',
    },
    '&>div>div': {
      flexDirection: 'row !important',
      height: 'inherit !important',
    },
    '&>div>div>*': {
      margin: '0.3em !important',
    },
  },
  tabContent: {
    marginTop: '3em',
    '@media (min-width: 1000px)': {
      '&:before': {
        background: '#90a4ae',
        content: "''",
        display: 'block',
        height: '100%',
        left: '40px',
        position: 'absolute',
        top: '10px',
        width: '1px',
        zIndex: 0,
      },
    },
  },
  inkBarStyle: {
    background: '#3e5a6d',
    height: '0.4em',
  },
  tabIcon: {
    color: '#90a4ae !important',
    '&.active': {
      color: '#3e5a6d !important',
    },
  },
  subjectInput: {
    padding: '0 18px 0 18px',
    width: '100% !important',
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    paddingBottom: '1em',
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};

class NewActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '',
      attachedFiles: [],
      comment: '',
      rates: [],
      subject: '',
    };
  }
  componentWillMount() {
  }
  componentDidMount() {
    this.handleActive({ props: { 'data-activity': 'message' } });
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.newActivitySending
      && !this.props.newActivitySending
      && !this.props.newActivitySendingError
    ) {
      this.setState({
        comment: '',
        subject: '',
        attachedFiles: [],
        rates: [],
      });
      this.clearInput();
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
  handleActive = (tab) => {
    const { props: { 'data-activity': activeTab } } = tab;
    this.setState({
      activeTab,
    });
  }
  updateDimensions = () => {
    const findDom = (document.getElementsByClassName(this.props.classes.tabs) || [null])[0];
    if (findDom && findDom.clientWidth) {
      const width = findDom.clientWidth;
      this.setState({ width });
    }
  }
  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  }
  sendActivity = () => {
    const { activeTab, rates, attachedFiles, subject, comment } = this.state;
    const { partnerInfo: { companyName, companyId = '' } } = this.props;
    const isEmail = companyId.indexOf('@') > -1;
    switch (activeTab) {
      case 'internalNote': // sending a note
      // TODO: NOW
        this.props.sendMessage({
          partnerId: companyId,
          message: {
            files: attachedFiles,
            messageText: comment,
            messageSubject: subject,
            type: 'note',
          },
        });
        break;
      case 'message':
        if (rates.length > 0) { // sending rates
          if (this.props.isSupplier) { // Supplier
            const { startDate, endDate, templateGroups = [''] } = rates[0];
            this.props.sendRates({
              startDate,
              endDate,
              templates: rates,
              templateGroupId: templateGroups[0],
              message: comment,
              bccSelf: false,
              partners: [
                {
                  companyName,
                  companyId: isEmail ? null : companyId,
                  email: isEmail ? companyId : null,
                },
              ],
              subject,
            });
          } else { // Buyer
            const {
              endDate,
              forGroupQuote,
              startDate,
              submissionCriteria,
              taxId,
              termsAndConditions,
              termsRadioButtonValue,
            } = rates[0];
            this.props.sendRateRequest({
              customizedMessage: comment,
              endDate,
              startDate,
              subject,
              taxId,
              forGroupQuote,
              contractPartners: [
                {
                  companyName,
                  companyId: isEmail ? null : companyId,
                  email: isEmail ? companyId : null,
                  companyType: 'Supplier',
                },
              ],
              ...(forGroupQuote === 'yes' ? {
                submissionCriteria,
              } : {}),
              ...(termsRadioButtonValue === 'yes' ? {
                termsAndConditions,
              } : {}),
            },
            );
          }
        } else { // sending a message
          this.props.sendMessage({
            partnerId: companyId,
            message: {
              files: attachedFiles,
              messageText: comment,
              messageSubject: subject,
            },
          });
        }
        break;
      default:
    }
  }
  render() {
    const {
      action,
      classes,
      newActivitySending,
      partnerInfoLoaded,
      partnerInfoLoading,
      partnerInfo: { companyType },
    } = this.props;
    const { activeTab, width } = this.state;
    if (partnerInfoLoading) {
      return (
        <Paper className={classes.content}>
          <div className={classes.loading}>
            <CircularProgress />
          </div>
        </Paper>
      );
    }
    if (partnerInfoLoaded) {
      return (
        <Paper className={classes.content}>
          <Tabs
            className={classes.tabs}
            inkBarStyle={styles.inkBarStyle}
          >
            {[
              <Tab
                label="Message"
                data-activity="message"
                key="message"
                onActive={this.handleActive}
                className={`${classes.tab}${activeTab === 'message' ? ' active' : ''}`}
                icon={<FontIcon className={`material-icons ${classes.tabIcon}${activeTab === 'message' ? ' active' : ''}`}>mail</FontIcon>}
              >
                <TextField
                  hintText="Enter subject here..."
                  name="subject"
                  className={classes.subjectInput}
                  value={this.state.subject}
                  underlineStyle={{ position: 'relative' }}
                  onChange={this.handleChange}
                  disabled={newActivitySending}
                  errorText={Boolean(this.state.rates.length > 0 && !this.state.subject) && 'Required'}
                />
              </Tab>,
              <Tab
                label="Internal Note"
                data-activity="internalNote"
                key="internalNote"
                onActive={this.handleActive}
                className={`${classes.tab}${activeTab === 'internalNote' ? ' active' : ''}`}
                icon={<FontIcon className={`material-icons ${classes.tabIcon}${activeTab === 'internalNote' ? ' active' : ''}`}>border_color</FontIcon>}
              />,
              <Tab
                label=""
                key="spacer0"
                disabled
                className={classes.tab}
              />,
              ...(width > 650) ? [
                <Tab
                  label=""
                  key="spacer1"
                  disabled
                  className={classes.tab}
                />,
              ] : [],
              ...(width > 800) ? [
                <Tab
                  label=""
                  key="spacer2"
                  disabled
                  className={classes.tab}
                />,
              ] : [],
            ].map(e => e)}
          </Tabs>
          <CommentBox
            hintText="Enter message body here..."
            hideMesageBoxIcon
            borderless
            attachedFiles={this.state.attachedFiles}
            setRates={(rates) => this.setState({ rates })}
            hideActions={(this.state.rates.length > 0 && !this.state.subject)}
            disableSend={newActivitySending}
            attachFile={(fileList) => {
              action('attachFile')(fileList);
              this.setState({ attachedFiles: fileList });
            }}
            comment={this.state.comment}
            cancelComment={() => {
              this.setState({ comment: '', subject: '' });
              this.clearInput();
            }}
            setClear={clear => this.clearInput = clear}
            handleInput={(textInput) => {
              action('handleInput')(textInput);
              this.setState({ comment: textInput });
            }}
            submitComment={() => {
              action('submitComment');
              this.sendActivity();
            }}
            {...(activeTab === 'internalNote' ? { internal: true }
            : { showContracting: true, receiverCompanyType: companyType })}
          />
        {/* <CommentBoxWrapper
            cancelComment={action('cancelComment')}
            className={text('className', '')}
            contractId={text('contractId', defaultGuid)}
            disableSend={boolean('disableSend', false)}
            submitComment={action('submitComment')}
          /> */}
        </Paper>
      );
    }
    return (
      <Paper className={classes.content}>
        <div className={classes.loading}>
          <RefreshIndicator
            percentage={80}
            size={60}
            left={0}
            top={0}
            color="red"
            status="ready"
            style={styles.refresh}
          />
        </div>
      </Paper>
    );
  }
}

NewActivity.defaultProps = {
  action: () => () => {},
  partnerInfo: {},
};

NewActivity.propTypes = {
  action: PropTypes.func.isRequired,
  classes: PropTypes.object,
  isSupplier: PropTypes.bool,
  newActivitySending: PropTypes.bool,
  newActivitySendingError: PropTypes.bool,
  partnerInfo: PropTypes.object,
  partnerInfoLoaded: PropTypes.bool,
  partnerInfoLoading: PropTypes.bool,
  sendMessage: PropTypes.func,
  sendRateRequest: PropTypes.func,
  sendRates: PropTypes.func,
};

const select = ({
  partnerDetails: {
    newActivitySending,
    newActivitySendingError,
    partnerInfo,
    partnerInfoLoaded,
    partnerInfoLoading,
  },
  user,
}) => ({
  isSupplier: user.getIn(['user', 'type']) === 'Supplier',
  newActivitySending,
  newActivitySendingError,
  partnerInfo,
  partnerInfoLoaded,
  partnerInfoLoading,
});

export default connect(select, { sendMessage, sendRates, sendRateRequest })(injectSheet(styles)(NewActivity));



// WEBPACK FOOTER //
// ./src/app/components/partner-details/new-activity.jsx